import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const testAutomationSlice = createSlice({
  name: "testAutomation",
  initialState,
  reducers: {
    createAutomationEntry: (state, action) => {
      const { locationKey } = action.payload;
      if (!state[locationKey]) {
        state[locationKey] = {};
      }
    },
    removeAutomationEntry: (state, action) => {
      const { locationKey } = action.payload;
      delete state[locationKey];
    },
    clearAllAutomation: (state) => {
      Object.keys(state).forEach((key) => delete state[key]);
    },
  },
  extraReducers: (builder) => {
    builder.addCase("testAutomation/webAutomation/set", (state, action) => {
      const { locationKey } = action.payload;
      if (!state[locationKey]) state[locationKey] = {};
      state[locationKey].webAutomation = {};
    });

    builder.addCase("testAutomation/webAutomation/update", (state, action) => {
      const { locationKey, key, value } = action.payload;
      if (!state[locationKey]) state[locationKey] = {};
      if (!state[locationKey].webAutomation) state[locationKey].webAutomation = {};
      state[locationKey].webAutomation[key] = value;
    });
  },
});

export const { createAutomationEntry, removeAutomationEntry, clearAllAutomation } =
  testAutomationSlice.actions;

export default testAutomationSlice.reducer;
